import * as React from 'react';
import { Dialog } from '@mend/mui';
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';

function noop() {
  return void 0;
}

export function FiltersDisclaimerDialog(props: {
  onClose: () => void;
  onOk: (doNotShowAgain: boolean) => void;
}) {
  const titleId = React.useId();

  const [doNotShowAgain, setDoNotShowAgain] = React.useState(false);

  return (
    <Dialog.Root open onClose={noop} maxWidth="sm" aria-labelledby={titleId} closeButton={null}>
      <Dialog.Header>
        <Dialog.Title id={titleId}>Temporary Filters Applied</Dialog.Title>
      </Dialog.Header>

      <Dialog.Content>
        <Typography variant="body1" mb={1}>
          New filters applied in this drilldown will be reset when you exit.
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={doNotShowAgain}
              onChange={(event) => setDoNotShowAgain(event.target.checked)}
            />
          }
          label="Do not show again"
        />
      </Dialog.Content>

      <Dialog.Footer>
        <Button color="neutral" variant="outlined" size="large" onClick={props.onClose}>
          Dismiss
        </Button>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          onClick={() => props.onOk(doNotShowAgain)}
        >
          OK
        </Button>
      </Dialog.Footer>
    </Dialog.Root>
  );
}
